import { getResponseFromApi } from "./Api";
import { Constants } from "./Constants";
// import { getUsernameAndArn } from "./QuickSightWorkerService";
import { sessionHelper } from "./SessionHelper";


export interface ILoginModel {
    client_id: string;
    grant_type: string;
    username?: string;
    password?: string;
};

export interface ITokenModel {
    access_token: string;
    refresh_token: string;
};

export interface ITwoFactorRequestModel {
    guid?: string;
    mobileNumber?: string;
};

export interface ITwoFactorCodeRequestModel {
    guid?: string;
    code?: string;
};

export interface IGreyFleetDriverRequestModel {
    [key: string]: any;
    vehicle_registration?: string;
    insured_for_business?: boolean;
    insurance_provider?: string;
    insurance_policy_start_date?: string;
    insurance_policy_end_date?: string;
    photo_1_data?: string;
    photo_1_name?: string;
    photo_2_data?: string;
    photo_2_name?: string;
    photo_3_data?: string;
    photo_3_name?: string;
    photo_4_data?: string;
    photo_4_name?: string;
    photo_5_data?: string;
    photo_5_name?: string;
    breakdown_provider?: string;
    breakdown_policy_start_date?: string;
    breakdown_policy_end_date?: string;
};

export interface IGreyFleetDriverResponseModel {
    [key: string]: any;
    vehicle_registration?: string;
    insured_for_business?: boolean;
    insurance_provider?: string;
    insurance_policy_start_date?: string;
    insurance_policy_end_date?: string;
    breakdown_provider?: string;
    breakdown_policy_start_date?: string;
    breakdown_policy_end_date?: string;
    photo_1_url?: string;
    photo_2_url?: string;
    photo_3_url?: string;
    photo_4_url?: string;
    photo_5_url?: string;
    mot_renewal_date?: string;
    road_tax_renewal_date?: string;
};


export const isUserAuthenticated = async () => {
    if(sessionHelper.accessToken){
        const tokenExpiration = new Date(sessionHelper.tokenExpiresIn);
        const currDate = new Date();
    
        if(sessionHelper.tokenExpiresIn > 0 && (tokenExpiration >= currDate)){
            return true;
        }

        await getTokenUsingRefresh();
        return true;
    }

    return false;
};

export const getToken = async (username: string, passsword: string) => {
    const loginModel: ILoginModel = {
        client_id: "11",
        grant_type: "password",
        username: username, 
        password: passsword
    };

    const requestInit: RequestInit = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "text/json"
        },
        body: JSON.stringify(loginModel)
    };

    const url = `${Constants.BASE_URL}/OAuth/token`;
    const resp = await getResponseFromApi(url, requestInit);

    const token = await processResponse(resp);

    sessionHelper.accessToken = token?.access_token;
    sessionHelper.refreshToken = token?.refresh_token;
    sessionHelper.userName = username;

    // const z = await getUsernameAndArn(username);
    // sessionHelper.userArn = z.Arn;

    const currDate = new Date();
    sessionHelper.tokenExpiresIn = currDate.setSeconds(currDate.getSeconds() + token?.expires_in);

    if(token === null){
        throw new Error("User not found");
    }
};

export const getTokenUsingRefresh = async () => {
    const refreshTokenModel = {
        client_id: "0",
        grant_type: "refresh_token",
        refresh_token: sessionHelper.refreshToken 
    };

    const requestInit: RequestInit = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "text/json"
        },
        body: JSON.stringify(refreshTokenModel)
    };

    const url = `${Constants.BASE_URL}/OAuth/token`;

    try {
        const resp = await getResponseFromApi(url, requestInit);
    
        const token = await processResponse(resp);
        sessionHelper.accessToken = token?.access_token;
        sessionHelper.refreshToken = token?.refresh_token;
    
        const currDate = new Date();
        sessionHelper.tokenExpiresIn = currDate.setSeconds(currDate.getSeconds() + token?.expires_in);
    } catch (error: any) {
        sessionHelper.accessToken = undefined;
        sessionHelper.refreshToken = undefined;
        window.location.href = "/login";
    }

};

export const changePassword = async (oldPassword: string, newPassword: string, confirmPassword: string) => {
    try {
        const model = {
            "OldPassword": oldPassword,
            "NewPassword": newPassword,
            "ConfirmPassword": confirmPassword
        };

        const requestInit: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "text/json"
            },
            body: JSON.stringify(model)
        };
    
        const url = `${Constants.BASE_URL}/api/SocialDriver/ChangePassword`;
        const resp = await getResponseFromApi(url, requestInit);
    
        return await processResponse(resp);

    } catch (error: any) {
        throw error;
    }
};

export const changeTempToUserPwd = async (username: string, tempPassword: string, newPassword: string, confirmPassword: string) => {
    try {
        const model = {
            "AppId": "11",
            "Username": username,
            "TemporaryPassword": tempPassword,
            "NewPassword": newPassword
        };

        const requestInit: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "text/json"
            },
            body: JSON.stringify(model)
        };
    
        const url = `${Constants.BASE_URL}/api/SocialDriver/ChangeTemporaryPassword`;
        const resp = await getResponseFromApi(url, requestInit);
    
        return await processResponse(resp);

    } catch (error: any) {
        throw error;
    }
};

export const forgottenPassword = async (userName: string) => {
    try {
        const model = {
            "AppId": "11",
            "Username": userName
        };

        const requestInit: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(model)
        };
    
        const url = `${Constants.BASE_URL}/api/SocialDriver/ForgottenPassword`;
        const resp = await getResponseFromApi(url, requestInit);
    
        return await processResponse(resp);

    } catch (error: any) {
        console.error("ERROR in WorkerService forgottenPassword ==>", error.message )
        throw error;
    }
};

export const changeForgottenPassword = async (userName: string, newPassword: string, confirmationCode: string) => {
    try {
        const model = {
            "AppId": "11",
            "Username": userName,
            "Password": newPassword,
            "ConfirmationCode": confirmationCode
        };

        const requestInit: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "text/json"
            },
            body: JSON.stringify(model)
        };
    
        const url = `${Constants.BASE_URL}/api/SocialDriver/changeForgottenPassword`;
        const resp = await getResponseFromApi(url, requestInit);
    
        return await processResponse(resp);

    } catch (error: any) {
        throw error;
    }
};


export const getGreyFleetDriver = async () : Promise<IGreyFleetDriverResponseModel> => {
    try {
        const requestInit: RequestInit = {
            method: "GET",
        };
    
        const url = `${Constants.BASE_URL}/apioauth/greyfleet/driver`;
        const resp = await  getResponseFromApi(url, requestInit);
        const result =  processResponse(resp);
    
        return result;

    } catch (error: any) {
        throw error;
    }
};

export const saveGreyFleetDriver = async (httpMethod: string, data?: IGreyFleetDriverRequestModel) : Promise<IGreyFleetDriverResponseModel> => {
    try {
        const requestInit: RequestInit = {
            method: httpMethod,
            headers: {
                "Content-Type" : "application/json"
            },
            body: JSON.stringify(data)
        };
    
        const url = `${Constants.BASE_URL}/apioauth/greyfleet/driver`;
        const resp = await  getResponseFromApi(url, requestInit);
        const result =  processResponse(resp);
    
        return result;

    } catch (error: any) {
        throw error;
    }
};


const processResponse = (resp: Response) => {
    if (resp.status === 404 || resp.status === 204) {
        return null;
    }

    try {       
        return resp.text().then(data => {
            let msgdata = data ? JSON.parse(data) : undefined;

            if(!resp.ok){
                const message = `Failed fetch from API ${Constants.BASE_URL}: ${resp.status}-${resp.statusText} - Message: ${msgdata.Message}`;
                console.error(message);

                if(msgdata.Message){
                    throw new Error(msgdata.Message);
                }
                throw new Error(message);
            }

            if(!msgdata){
                msgdata = {success: true};
            }

            return msgdata;
        });
    } catch (error) {
        console.log("ERROR in processResponse: ", error);
    }

    // try {
    //     return resp.json().then(data => {
    //         return data;
    //     });
    // } catch (error) {
    //     console.log("ERROR in processResponse: ", error);
    // }
};


